"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertLevelCell = AlertLevelCell;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AlertLevelClasses = require("./AlertLevelClasses");

var _cssModifierUtilities = require("../utilities/cssModifierUtilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function AlertLevelCell(_ref) {
  var alertLevelId = _ref.alertLevelId,
      children = _ref.children,
      cssClassModifiers = _ref.cssClassModifiers;
  var alertClass = (0, _AlertLevelClasses.getAlertLevelClass)(alertLevelId);
  var cellClass = (0, _cssModifierUtilities.buildClassName)('table-cell', cssClassModifiers);
  return /*#__PURE__*/_react["default"].createElement("td", {
    className: "".concat(alertClass, " ").concat(cellClass)
  }, children);
}

AlertLevelCell.propTypes = {
  alertLevelId: _propTypes["default"].number,
  children: _propTypes["default"].node,
  cssClassModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
AlertLevelCell.defaultProps = {
  alertLevelId: null,
  children: null,
  cssClassModifiers: []
};